import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import { defaultPermissions } from 'helpers/permissionsHelper';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import RoleDialog from 'components/landlord_app/users/RoleDialog';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import { deepDiver } from 'helpers/utilities';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';

export default class CompanyRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roleDetails: null,
      dialogOpen: false,
      confirmDialogOpen: false,
      roleIdToDelete: null,
    };
  }

  toggleRoleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  toggleConfirmDialog = (open = true) => {
    this.setState({
      confirmDialogOpen: open,
    });
  };

  render() {
    return (
      <div>
        <div
          className="row"
          style={{
            marginTop: '15px',
            textAlign: 'justify',
            fontSize: '14px',
            marginBottom: '15px',
          }}
        >
          {getTranslatedString('landLordPortal.companyRoles.description')}
        </div>

        {this.props.roles.map((role) => (
          <div key={role.id} className="row">
            <div className="col-xs-10" style={{ paddingLeft: '5px' }}>
              <p>{role.name}</p>
            </div>
            <div className="col-xs-1" style={{ padding: '0' }}>
              <button
                type="button"
                className="link-button"
                onClick={(event) => {
                  event.preventDefault();
                  this.toggleRoleDialog();
                  this.setState({ roleDetails: role });
                }}
                style={{ cursor: 'pointer' }}
              >
                {getTranslatedString('landLordPortal.companyRoles.edit')}
              </button>
            </div>
            <div className="col-xs-1" style={{ padding: '0', marginTop: '-15px' }}>
              <IconButton
                style={{
                  padding: 0,
                }}
                onClick={() => {
                  this.setState({ roleIdToDelete: role.id });
                  this.toggleConfirmDialog(true);
                }}
              >
                <DeleteIcon size={24} style={{ padding: 0 }} />
              </IconButton>
            </div>
          </div>
        ))}

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: 'center', marginTop: '15px' }}>
            <FlatButton
              label={getTranslatedString('landLordPortal.companyRoles.addRole')}
              primary={true}
              style={{ backgroundColor: AccentColor(), color: '#fff', marginBottom: '15px' }}
              onClick={() => {
                this.toggleRoleDialog();
                this.setState({ roleDetails: { permissions: defaultPermissions } });
              }}
            />
          </div>
        </div>
        <RoleDialog
          dialogOpen={this.state.dialogOpen}
          toggleDialog={this.toggleRoleDialog}
          roleDetails={{
            ...this.state.roleDetails,
            whitelisted_ips_enabled:
              (deepDiver(this.state, 'roleDetails.whitelisted_ips') || []).length > 0,
            sso_enabled: this.getSSOEnabled(),
          }}
          createOrUpdateCompanyRole={this.props.createOrUpdateCompanyRole}
        />

        <ConfirmationDialog
          showDialog={this.state.confirmDialogOpen}
          hideDialog={() => this.toggleConfirmDialog(false)}
          userConfirmVerbiage={getTranslatedString('landLordPortal.companyRoles.delete')}
          dialogTitle={getTranslatedString('landLordPortal.companyRoles.deleteTitle')}
          dialogBodyVerbiage={getTranslatedString('landLordPortal.companyRoles.confirm')}
          userConfirmAction={() => {
            this.props.deleteCompanyRole(this.state.roleIdToDelete);
            this.toggleConfirmDialog(false);
          }}
        />
      </div>
    );
  }

  getSSOEnabled() {
    if (!deepDiver(this.state, 'roleDetails.id') && hostIsCapreit()) {
      return true;
    }

    return deepDiver(this.state, 'roleDetails.sso_enabled');
  }
}
